// Import Views

// Dashboard
import Giveaways from 'views/Dashboard/Giveaways';

// Auth
import SignIn from 'views/Auth/SignIn.js';
import Forgot from 'views/Auth/Forgot.js';

// import SlotMachineOld from 'views/Game/slot-machine-old/SlotMachineOld.js';
// import SlotMachineNew from 'views/Game/slot-machine-new/SlotMachineNew.js';
import SlotMachine from 'views/Game/slot-machine/SlotMachine.js';

import {
  DocumentIcon,
  GiveawaysIcon,
  GiveawaysActiveIcon,
} from 'components/Icons/Icons'; 
import SlotMachineMrr from './views/Game/slot-machine-mrr/SlotMachineMrr';

export const sidebar = [
  {
    path: 'giveaways',
    name: 'Giveaways',
    rtlName: 'لوحة القيادة',
    icon: <GiveawaysIcon color="#8794C2" />,
    iconActive: <GiveawaysActiveIcon color="#099BFF" />,
    component: Giveaways,
    layout: '/',
  },
  {
    path: 'daily-giveaways',
    name: 'Daily Giveaways',
    rtlName: 'لوحة القيادة',
    icon: <GiveawaysIcon color="#8794C2" />,
    iconActive: <GiveawaysActiveIcon color="#099BFF" />,
    component: Giveaways,
    layout: '/',
  },
];

export const other = [
  // {
  //   path: 'settings',
  //   name: 'Settings',
  //   rtlName: 'لوحة القيادة',
  //   icon: <HomeIcon color="inherit" />,
  //   component: Settings,
  //   layout: '/',
  // }
];

export const game = [
  // {
  //   path: '/slot-machine-old/:giveawayId',
  //   name: 'Slot Machine Old',
  //   component: SlotMachineOld,
  //   layout: '/game',
  // },
  // {
  //   path: '/slot-machine-new/:giveawayId',
  //   name: 'Slot Machine New',
  //   component: SlotMachineNew,
  //   layout: '/game',
  // },
  {
    path: '/slot-machine/:giveawayId',
    name: 'Slot Machine',
    component: SlotMachine,
    layout: '/game',
  },
  {
    path: '/slot-machine-mrr/:giveawayId',
    name: 'Slot Machine',
    component: SlotMachineMrr,
    layout: '/game',
  },
];

export const auth = [
  {
    name: 'AUTH',
    category: 'account',
    rtlName: 'صفحات',
    state: 'pageCollapse',
    views: [
      {
        path: '/signin',
        name: 'Sign In',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: SignIn,
        layout: '/auth',
      },
      {
        path: '/forgot-password',
        name: 'Forgot Password',
        rtlName: 'لوحة القيادة',
        icon: <DocumentIcon color="inherit" />,
        component: Forgot,
        layout: '/auth',
      },
    ],
  },
];

const routes = [...sidebar, ...other, ...auth, ...game];
export default routes;
